/**
 * Services is a WIP behind `EXPO_PUBLIC_SERVICES_ENABLED`.
 *
 * Con el flag apagado el botón del menú SÍ existe (así lo pidió producto) y
 * esta ventana es su pantalla: dice lo que es verdad — la vertical viene — en
 * lugar de renderizar un catálogo cuyas solicitudes el backend todavía no
 * sirve. `services/_layout` la usa para el root del tab y para deep links; con
 * el flag encendido, ese layout monta el funnel real y esta pantalla queda
 * inalcanzable.
 */
import { View, Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { HardHat } from '@/components/ui/icons'
import { ScreenContainer } from '@/components/ui/ScreenContainer'
import { useSemanticColors, SPACING } from '@/lib/theme/tokens'
import { useTheme } from '@/lib/hooks/use-theme'
import { FONTS } from '@/lib/brand'

export function ServicesComingSoon() {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)

  return (
    <ScreenContainer>
      <View
        testID="services.coming-soon"
        style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: SPACING.xl }}
      >
        <HardHat size={48} color={colors.textMuted} strokeWidth={1.5} />
        <Text
          style={{
            fontSize: 20,
            fontFamily: FONTS.bodyBold,
            color: colors.textPrimary,
            textAlign: 'center',
            marginTop: SPACING.md,
            marginBottom: SPACING.xs,
          }}
        >
          {t('services.coming_soon_title')}
        </Text>
        <Text
          style={{
            maxWidth: 320,
            fontSize: 15,
            fontFamily: FONTS.body,
            color: colors.textSecondary,
            textAlign: 'center',
            lineHeight: 22,
          }}
        >
          {t('services.coming_soon_body')}
        </Text>
      </View>
    </ScreenContainer>
  )
}
